import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const DRAWER_WIDTH = 240;
export const DRAWER_WIDTH_COLLAPSED = 64;

const SIDE_MENU_STORAGE_KEY = "sideMenu:isExpanded";

const getInitialExpandedState = (): boolean => {
  try {
    const saved = localStorage.getItem(SIDE_MENU_STORAGE_KEY);
    if (saved !== null) {
      const parsed: unknown = JSON.parse(saved);
      return typeof parsed === "boolean" ? parsed : true;
    }
    return true;
  } catch {
    return true;
  }
};

const saveExpandedState = (isExpanded: boolean): void => {
  try {
    localStorage.setItem(SIDE_MENU_STORAGE_KEY, JSON.stringify(isExpanded));
  } catch {
    // Persistence is best-effort when localStorage is unavailable.
  }
};

export interface SideMenuState {
  isExpanded: boolean;
}

const initialState: SideMenuState = {
  isExpanded: getInitialExpandedState(),
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    toggleSideMenu: (state) => {
      state.isExpanded = !state.isExpanded;
      saveExpandedState(state.isExpanded);
    },
    setSideMenuExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
      saveExpandedState(state.isExpanded);
    },
  },
});

export const { toggleSideMenu, setSideMenuExpanded } = sideMenuSlice.actions;

export default sideMenuSlice.reducer;
